import { render, staticRenderFns } from "./teaching-center-list.vue?vue&type=template&id=f2dbde08"
import script from "./teaching-center-list.vue?vue&type=script&lang=ts"
export * from "./teaching-center-list.vue?vue&type=script&lang=ts"
import style0 from "./teaching-center-list.vue?vue&type=style&index=0&id=f2dbde08&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports